import { useEffect, useRef } from 'react';
import { useAriaLive } from '@ally/use-aria-live';
import { haveOptionsChanged } from '../utils';
import { useDebounce } from '../../../../tools/utils';
var announcementText = function (optionsLength) {
    if (!optionsLength) {
        return 'No results available.';
    }
    return "".concat(optionsLength, " ").concat(optionsLength === 1 ? 'result' : 'results', " available. Use up and down arrows to select.");
};
export var useAnnouncements = function (_a) {
    var inputValue = _a.inputValue, minSearchChars = _a.minSearchChars, filteredOptions = _a.filteredOptions, showOptions = _a.showOptions, isLoading = _a.isLoading;
    var staticPrevFilteredOptions = useRef([]);
    var announcePolite = useAriaLive().announcePolite;
    // giving the announcements additional time so that it doesn't queue
    // its announcement until after the ui changes are queued by the SR
    var debounceAriaLive = useDebounce({
        debounceTimeout: 500,
        onDebounced: announcePolite,
        cancelDebounce: function () {
            return inputValue.length < minSearchChars || (!showOptions && !isLoading);
        },
    }).handleValueChange;
    useEffect(function () {
        if (haveOptionsChanged(staticPrevFilteredOptions.current, filteredOptions)) {
            debounceAriaLive(announcementText(filteredOptions.length));
            staticPrevFilteredOptions.current = filteredOptions.slice();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredOptions]);
};
//# sourceMappingURL=useAnnouncements.js.map